<template>
  <b-container>
    <div v-if="loadError" class="text-danger user-load-error">{{$t('user_load_error')}}
      <b-button class="user-load-retry" type="button" :disabled="isBusy" @click="loadData">{{$t('retry')}}</b-button>
    </div>
    <ValidationObserver ref="userCreateForm" v-slot="{ invalid }">
    <b-form
        @submit.prevent="onSubmit"
    >
      <fieldset :disabled="saving || isBusy">
      <validation-provider vid="organisationId" v-slot="{ errors }" rules="required" >
      <b-form-group
          label-for="organisation"
          :label="$t('user.create.organisation')"
      >
        <b-form-select
            id="organisation"
            v-model="form.organisationId"
            placeholder="organisation"
            :options="organisationList"
            value-field="id"
            text-field="name"
        />
        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="type" v-slot="{ errors }" rules="required" >
      <b-form-group
          label-for="type"
          :label="$t('user.create.type')"
      >
        <b-form-select
          id="type"
          :options="typeList"
          value-field="id"
          text-field="name"
          v-model="form.type"
          :placeholder="$t('user.create.type.placeholder')"
        >
        </b-form-select>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider
          vid="login" v-slot="{ errors }" rules="required|min:5|max:50|login" >
      <b-form-group
          label-for="login"
          :label="$t('user.create.login')"
      >
        <b-input
          id="login"
          v-model="form.login"
          :placeholder="$t('user.create.login.placeholder')"
        >
        </b-input>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="password" v-slot="{ errors }" rules="required|min:5|max:255|password" >
      <b-form-group
          label-for="password"
          :label="$t('user.create.password')"
      >
        <b-input
          id="password"
          type="password"
          v-model="form.password"
          aria-describedby=""
          :placeholder="$t('user.create.password.placeholder')"
        >
        </b-input>
<!--        <b-form-text id="password-help-block">-->
<!--          {{$t('password-help-block')}}-->
<!--        </b-form-text>-->

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="name" v-slot="{ errors }" rules="required|unicodeLength:5,255|userName" >
      <b-form-group
          label-for="name"
          :label="$t('user.create.name')"
      >
        <b-input
          id="name"
          v-model="form.name"
          :placeholder="$t('user.create.name')"
        >
        </b-input>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="phone" v-slot="{ errors }" rules="required|phone" >
      <b-form-group
          label-for="phone"
          :label="$t('user.create.phone')"
      >
        <b-input
          id="phone"
          v-model="form.phone"
          :placeholder="$t('user.create.phone')"
        >
        </b-input>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <validation-provider vid="email" v-slot="{ errors }" rules="required|email" >
      <b-form-group
          label-for="email"
          :label="$t('user.create.email')"
      >
        <b-input
          id="email"
          v-model="form.email"
          :placeholder="$t('user.create.email')"
        >
        </b-input>

        <span class="text-danger">{{ errors[0] }}</span>
      </b-form-group>
      </validation-provider>
      <div v-if="responseError" class="text-danger user-save-error">
          {{$t('saved_error')}} <br>
          {{responseErrorMessage}}
      </div>
      <span v-if="created">
        <div>
          {{$t('saved_successful')}}
        </div>
      </span>
      <b-button
          :disabled="invalid || saving || isBusy || loadError"
          type="submit"
          variant="primary"
      >{{$t('user.create')}}</b-button>

    </fieldset>
    </b-form>
    </ValidationObserver>
  </b-container>
</template>

<script>
import axios from "axios";
import { saveForm } from "../../utils/SaveForm";
import { isUserPayloadValid } from "../../utils/FormValidation";
import { REQUEST_TIMEOUT_MS } from "../../utils/RequestGuard";

export default {
  name: "Create",
  data() {
    return {
        isBusy: true, loadError: false, saving: false, disposed: false, requestVersion: 0, readVersion: 0,
        organisationList: [],
        typeList: [
            {id: 'admin', name: 'admin'},
            {id: 'user', name: 'user'}
          ],
        form: {
            organisationId: null,
            type: null,
            login: null,
            password: null,
            name: null,
            phone: null,
            email: null,
        },
        responseError: false,
        responseErrorMessage: null,
        created: false
    }
  },
  methods: {
    onSubmit() {
      if (this.isBusy || this.loadError) return;
      const payload = { ...this.form };
      return saveForm(this, { method: 'put', url: 'api/v1/users', payload,
        observer: 'userCreateForm', success: 'created', event: 'onCreated',
        fields: ['organisationId', 'type', 'login', 'password', 'name', 'phone', 'email'],
        validPayload: value => isUserPayloadValid(value, false, this.organisationList.map(item => item.id)),
      });
    },
    async loadData() {
      if (this.disposed) return;
      const request = ++this.readVersion;
      this.requestVersion++; this.saving = false; this.isBusy = true; this.loadError = false; this.responseError = false;
      this.created = false;
      try {
        const response = await axios.get('api/v1/users/distibutors', { timeout: REQUEST_TIMEOUT_MS });
        if (this.disposed || request !== this.readVersion) return;
        if (!Array.isArray(response.data.rows)) throw new Error('Invalid organisation list');
        this.organisationList = response.data.rows;
      } catch (error) {
        if (!this.disposed && request === this.readVersion && error.response?.status !== 401) this.loadError = true;
      } finally { if (!this.disposed && request === this.readVersion) this.isBusy = false; }
    }

  },
  mounted() { this.loadData(); },
  beforeDestroy() { this.disposed = true; this.requestVersion++; this.readVersion++; },
}
</script>

<style scoped>

</style>